import React from 'react'
import styles from './SkillPaths.module.scss';

const EmptyStateCard = ({emptyStateText = 'No Data to show'}) => {
  return (
    <div className={styles.progressChart}>
      <div className={styles.emptyStateText}>{emptyStateText}</div>
    </div>
  );
}

export default EmptyStateCard